module.exports = __webpack_public_path__ + "img/icon_home_01.096d9e3b.png";